import produce from 'immer';
import { NFT_INVENTORY_VALID_UPDATE_REQUEST } from '../../constants/inventory/nftInventoryValidUpdateConstants';

const initialState = {

};

const nftInventoryValidUpdateReducer = (state = initialState, action = {}) => produce(state, draft => {
  switch (action.type) {
    case NFT_INVENTORY_VALID_UPDATE_REQUEST:
      break;
    default:
      break;
  }
});

export default nftInventoryValidUpdateReducer;
